import NewsItem from './components/NewsItem';
import Footer from '../../components/Footer';
import { useEffect, useMemo, useState } from 'react';
import Pagination from './components/Pagination';
import Header from '../../components/Header';
import { useSearchParams } from 'react-router-dom';

export default function NewsPage() {

  const [searchParams, setSearchParams] = useSearchParams();
  const [newsList, setNewsList] = useState([]);

  const curItems = useMemo(() => {
    const curPage = (+searchParams.get('page') || 1) - 1;
    const curBlock = (+searchParams.get('block') || 1) - 1;

    const start = curPage * 8;
    const end = (curPage + 1) * 8;

    return newsList.slice(start, end);
  }, [searchParams, newsList]);


  useEffect(() => {
    fetch(`${process.env.REACT_APP_STATIC_URL}/data/News_List.json`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => res.json().then(data => setNewsList(data)));
  }, []);

  return (
    <div >
      <Header />
      <main
        data-bg-type='white'
        className="wrapper my-[120px] lg:my-[190px]"
      >
        <h1 className="text-center text-title2 font-bold lg:text-display1 text-label-400">뉴스</h1>

        <div className="flex flex-wrap items-start justify-center gap-y-[40px] lg:gap-y-[120px] gap-x-[44px] mt-[60px] lg:mt-[140px]">
          {
            curItems.map(data => <NewsItem key={data.id} data={data} />)
          }
        </div>

        <Pagination totalLength={newsList.length} />
      </main>
      <Footer />
    </div>
  )
}